import React, {Component} from 'react';
import {Elements, StripeProvider} from 'react-stripe-elements';
import Helmet from 'react-helmet';
import CheckoutForm from './CheckoutForm';
import Layout from './Layout';
import { matchPath } from 'react-router';
import mixpanel, { initMixpanel } from '../utils/mixpanelConsent';

import AuthService from './AuthService';
import constants from '../config';
import { resolveCardImage } from '../utils/resolveImage';
import AuthModalContext from '../contexts/AuthModalContext';
import { GUEST_CHECKOUT_ENABLED } from '../config/constants';

const Auth = new AuthService();
initMixpanel();
var FLAT_SHIPPING_FEE = constants.FLAT_SHIPPING_FEE || 1.00;

class PurchaseSharedPost extends Component {
  static contextType = AuthModalContext;

  constructor() {
    super();
    this.state = {
      loadingIcon: 'none', // none
      loadingOpacity: 1, // 0.6
      loading: false,
      shippingValid: false,
    }
    // Post data
    this.product = this.product.bind(this);
    this.processPayment = this.processPayment.bind(this);
    this.paymentComplete = this.paymentComplete.bind(this);
    this.toggleTracking = this.toggleTracking.bind(this);
    this.onTaxChange = this.onTaxChange.bind(this);
    this.onShippingValidChange = this.onShippingValidChange.bind(this);
  }

  componentDidMount() {
    const match = matchPath(this.props.history.location.pathname, {
      path: '/metapurchase/:share_id',
      exact: false,
      strict: false,
    });
    const shareId = match.params.share_id;
    // Check for tracking upgrade from query param
    var search = this.props.history.location.search || '';
    if (search.indexOf('tracking=1') !== -1) {
      this.setState({ trackingUpgrade: true });
    }
    // Parse offer params from URL (when buyer comes through share link + accepted offer)
    var params = new URLSearchParams(search);
    var offerId = params.get('offerId');
    var offerPrice = params.get('offerPrice');
    if (offerId && offerPrice) {
      this.setState({ offerId: offerId, offerPrice: Number(offerPrice) });
    }
    this.product(shareId);
  }
  paypalRender(auth) {
    var self = this;
    if (window.paypal && window.paypal.Buttons) {
      self.paypalButton(auth);
      return;
    }
    var oldScript = document.querySelector('script[src*="paypalobjects.com/api/checkout.js"]');
    if (oldScript) oldScript.parentNode.removeChild(oldScript);
    var script = document.createElement('script');
    script.src = 'https://www.paypal.com/sdk/js?client-id=' + constants.PAYPAL_CLIENT_ID + '&currency=USD';
    script.async = true;
    script.onload = function() {
      self.paypalButton(auth);
    };
    document.body.appendChild(script);
  }
  paypalButton(auth) {
    var self = this;
    var container = document.getElementById('paypal-button');
    if (!window.paypal || !window.paypal.Buttons || !container) return;
    container.innerHTML = '';

    var headers = {};
    if (auth) headers['Authorization'] = auth;

    window.paypal.Buttons({
      style: {
        color: 'gold',
        shape: 'rect',
        layout: 'vertical',
      },
      createOrder: function() {
        self.setState({ paypalMessage: '' });
        // Build endpoint URL at call time so guest address is current
        var queryParts = [];
        if (self.state.trackingUpgrade) queryParts.push('trackingUpgrade=true');
        if (self.state.offerId) queryParts.push('offerId=' + self.state.offerId);
        if (!auth && self.state.guestZip) {
          queryParts.push('shippingZip=' + encodeURIComponent(self.state.guestZip));
          if (self.state.guestState) queryParts.push('shippingState=' + encodeURIComponent(self.state.guestState));
        }
        var queryStr = queryParts.length > 0 ? '?' + queryParts.join('&') : '';
        var purchaseId = self.state.purchaseId;
        var paypalEndpoint = auth ? self.state.paypalEndpoint : self.state.paypalGuestEndpoint;
        var endpoint = constants.DOMAIN + '/api/v1/transactions/' + purchaseId + '/' + paypalEndpoint + queryStr;
        return fetch(endpoint, {
          method: 'GET',
          headers: headers,
        })
        .then(function(resp) { return resp.json(); })
        .then(function(res) {
          if (res.url) {
            var match = res.url.match(/token=([^&]+)/);
            if (match) return match[1];
          }
          throw new Error('Failed to create PayPal order');
        });
      },
      onApprove: function(data) {
        window.location.href = '/order-confirmation?paypal_type=' + (auth ? 'auth' : 'guest') + '&token=' + data.orderID;
      },
      onCancel: function() {
        self.setState({ paypalMessage: 'Payment cancelled. You can try again when ready.' });
      },
      onError: function(err) {
        console.error('PayPal error:', err);
        self.setState({ paypalMessage: 'Something went wrong with PayPal. Please try again.' });
      },
    }).render('#paypal-button');
  }
  // MAIN PAGE FUNCTION
  product(share_id) {
    if (Auth.getToken()) { // User is signed in
      Auth.fetch(`${constants.DOMAIN}/api/v1/func/share/${share_id}`, {
        mode: 'cors',
        method: 'GET',
      })
        .then(res => {
          console.log('res',res);
          this.setState({
            productId: res.post_id,
            shareId: res._id,
            title: res.title,
            image1: resolveCardImage(res.cardImage) || resolveCardImage(res.images && res.images[0]) || '',
            price: res.price,
            shippingCost: res.shippingCost,
            seller: res.user,
            category: res.category,
            paypalEmail: res.user.paypalEmail,
            shareCommission: res.shareCommission || 5,
            shareCommissionType: res.shareCommissionType || 'percentage',
          }, () => {
            var p = Number(this.state.price) || 0;
            var computedShip = p >= (constants.FREE_SHIPPING_THRESHOLD || 10) ? 0 : FLAT_SHIPPING_FEE;
            this.handlePurchaseEndpoints(this.state.price, computedShip);
          });
        })
        .catch(err => {
          console.log(err);
        })
    } else { // User is a guest
      Auth.fetch(`${constants.DOMAIN}/api/v1/guest/share/${share_id}`, {
        mode: 'cors',
        method: 'GET',
      })
        .then(res => {
          console.log('res',res);
          this.setState({
            productId: res.post_id,
            shareId: res._id,
            title: res.title,
            image1: resolveCardImage(res.cardImage) || resolveCardImage(res.images && res.images[0]) || '',
            price: res.price,
            shippingCost: res.shippingCost,
            seller: res.user,
            category: res.category,
            paypalEmail: res.user.paypalEmail,
            shareCommission: res.shareCommission || 5,
            shareCommissionType: res.shareCommissionType || 'percentage',
          }, () => {
            var p = Number(this.state.price) || 0;
            var computedShip = p >= (constants.FREE_SHIPPING_THRESHOLD || 10) ? 0 : FLAT_SHIPPING_FEE;
            this.handlePurchaseEndpoints(this.state.price, computedShip);
          });
        })
        .catch(err => {
          console.log(err);
        })
    }
  }
  handlePurchaseEndpoints(price, shipping) {
    // stripePurchaseEndpoint customermetabuy shared post through stripe 1-click buy
    // paypalEndpoint paypalmetabuy shared post as user
    // paypalGuestEndpoint paypalmetaguest
    var effectivePrice = this.state.offerPrice || Number(price);
    var rawCommission = (this.state.shareCommissionType === 'percentage' || !this.state.shareCommissionType)
      ? Math.floor(effectivePrice * ((this.state.shareCommission || 5) / 100) * 100) / 100
      : Math.floor(Number(this.state.shareCommission || 1) * 100) / 100;
    var marketerAmount = Math.max(1.00, rawCommission);
    // Cap: marketer can't earn more than seller's base payout
    var baseSellerAmount = (effectivePrice * 0.90) + shipping;
    if (marketerAmount > baseSellerAmount) {
      marketerAmount = Math.max(0, Math.floor(baseSellerAmount * 100) / 100);
    }
    console.log('marketer amount on this share', marketerAmount);
      if (marketerAmount >= constants.MINIMAL_PROFIT) {
        // share endpoints enabled for user
        this.setState({
          paypalEndpoint: 'paypalmetabuy',
          paypalGuestEndpoint: 'paypalmetaguest',
          purchaseId: this.state.shareId,
        }, () => {
          console.log('STATE AFTER purchase update',this.state)
          this.paypalRender(Auth.getToken()); 
        })
      } else {
        // no share endpoints for user
        this.setState({
          paypalEndpoint: 'paypalbuy',
          paypalGuestEndpoint: 'paypalguest',
          purchaseId: this.state.productId,
          shareId: null,
        }, () => {
          console.log('STATE AFTER purchase update',this.state)
          this.paypalRender(Auth.getToken()); 
        })
      }
  }
  toggleTracking() {
    var self = this;
    this.setState({ trackingUpgrade: !this.state.trackingUpgrade }, function() {
      // Re-render PayPal button with updated tracking param
      var oldScript = document.getElementById('injectPaypal');
      if (oldScript) oldScript.parentNode.removeChild(oldScript);
      var paypalContainer = document.getElementById('paypal-button');
      if (paypalContainer) paypalContainer.innerHTML = '';
      self.paypalButton(Auth.getToken());
    });
  }
  processPayment() {
    if (this.state.loading === false) {
      this.setState({
        loadingIcon: 'inline',
        loadingOpacity: 0.6,
        loading:true,
      });
    }
  }
  onTaxChange(rate, loading, zip, state) {
    this.setState({ taxRate: rate || 0, taxLoading: !!loading, guestZip: zip || '', guestState: state || '' });
  }
  onShippingValidChange(isValid) {
    var self = this;
    this.setState({ shippingValid: isValid }, function() {
      if (isValid) {
        setTimeout(function() {
          self.paypalRender(Auth.getAuthHeader());
        }, 0);
      }
    });
  }
  paymentComplete() {
    mixpanel.track("Purchase", {"Price": this.state.price, "Item Category": this.state.category, "Seller": this.state.seller});
    try { localStorage.removeItem('primal_ref_' + this.state.productId); } catch (e) {}
    var confirmPrice = this.state.offerPrice || Number(this.state.price) || 0;
    var FREE_THRESHOLD = constants.FREE_SHIPPING_THRESHOLD || 10;
    var confirmShipping = confirmPrice >= FREE_THRESHOLD ? 0 : FLAT_SHIPPING_FEE;
    var confirmTrackingFee = this.state.trackingUpgrade && (confirmPrice + confirmShipping) < FREE_THRESHOLD ? (constants.TRACKING_UPGRADE_FEE || 5.50) : 0;
    var confirmTxFee = constants.TRANSACTION_FEE || 0.50;
    var confirmTax = Math.round(confirmPrice * (this.state.taxRate || 0) * 100) / 100;
    var confirmTotal = confirmPrice + confirmShipping + confirmTrackingFee + confirmTxFee + confirmTax;
    this.props.history.push('/order-confirmation', {
      title: this.state.title,
      image: this.state.image,
      price: confirmPrice,
      shippingCost: confirmShipping,
      trackingUpgradeFee: confirmTrackingFee,
      transactionFee: confirmTxFee,
      taxAmount: confirmTax,
      grandTotal: confirmTotal.toFixed(2),
      productId: this.state.productId,
    });
  }
  render() {
    var originalPrice = Number(this.state.price) || 0;
    var price = this.state.offerPrice || originalPrice;
    var hasOffer = this.state.offerPrice && this.state.offerPrice !== originalPrice;
    var FREE_THRESHOLD = constants.FREE_SHIPPING_THRESHOLD || 10;
    var shipping = price >= FREE_THRESHOLD ? 0 : FLAT_SHIPPING_FEE;
    var TRACKING_FEE = constants.TRACKING_UPGRADE_FEE || 3.49;
    var canUpgradeTracking = (price + shipping) < FREE_THRESHOLD;
    var trackingUpgrade = this.state.trackingUpgrade && canUpgradeTracking;
    var trackingFee = trackingUpgrade ? TRACKING_FEE : 0;
    var TRANSACTION_FEE = constants.TRANSACTION_FEE || 0.50;
    var taxRate = this.state.taxRate || 0;
    var taxAmount = Math.round(price * taxRate * 100) / 100;
    var total = price + shipping + trackingFee + TRANSACTION_FEE + taxAmount;

    return (
      <Layout>
        <Helmet>
          <title>Buy Now | Primal Marketplace</title>
          <meta name="description" content="Purchasing a product on Primal Marketplace" />
          <meta property="og:title"       content="Buy Now | Primal Marketplace" />
          <meta property="og:description" content="Purchasing a product on Primal Marketplace" />
          <meta property="og:image"       content="https://miro.medium.com/max/1400/1*oTgw9AhNIavpU4M6Y1tOKw.png" />
        </Helmet>

        {this.state.loading ? (
          <div className="tw-fixed tw-inset-0 tw-bg-black/30 tw-flex tw-items-center tw-justify-center tw-z-50">
            <div className="tw-animate-spin tw-rounded-full tw-h-10 tw-w-10 tw-border-t-2 tw-border-b-2" style={{ borderColor: '#c9a84c' }}></div>
          </div>
        ) : null}

        <div className="tw-max-w-4xl tw-mx-auto tw-px-4 tw-py-8">
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-5 tw-gap-8">
            {/* Left: Checkout form */}
            <div className="md:tw-col-span-3">
              <h1 className="tw-text-xl tw-font-bold tw-text-[#111] dark:tw-text-white tw-mb-6">Checkout</h1>
              {this.state.paypalMessage && (
                <div className="tw-bg-yellow-50 dark:tw-bg-yellow-900/20 tw-border tw-border-yellow-300 dark:tw-border-yellow-700 tw-rounded-lg tw-py-2.5 tw-px-4 tw-mb-4">
                  <p className="tw-text-yellow-700 dark:tw-text-yellow-300 tw-text-sm tw-mb-0">{this.state.paypalMessage}</p>
                </div>
              )}
              {!GUEST_CHECKOUT_ENABLED && !Auth.getToken() ? (
                <div className="tw-bg-gray-50 dark:tw-bg-[#1a1a1a] tw-border tw-border-[#e0e0e0] dark:tw-border-[#2a2a2a] tw-rounded-lg tw-p-6 tw-text-center">
                  <p className="tw-text-[#111] dark:tw-text-white tw-font-semibold tw-mb-2">
                    Sign in or create an account to purchase this card.
                  </p>
                  <p className="tw-text-[#555] dark:tw-text-[#aaa] tw-text-sm tw-mb-4">
                    An account is required to track your order, confirm receipt, and protect your purchase.
                  </p>
                  <div className="tw-flex tw-gap-3 tw-justify-center">
                    <button
                      onClick={function() { this.context.openAuthModal('login'); }.bind(this)}
                      className="tw-bg-brand-gold tw-text-black tw-font-bold tw-py-2 tw-px-5 tw-rounded-lg tw-border-0 tw-cursor-pointer tw-text-sm"
                    >
                      Sign In
                    </button>
                    <button
                      onClick={function() { this.context.openAuthModal('signup'); }.bind(this)}
                      className="tw-bg-transparent tw-text-brand-gold tw-font-bold tw-py-2 tw-px-5 tw-rounded-lg tw-border tw-border-brand-gold tw-cursor-pointer tw-text-sm"
                    >
                      Create Account
                    </button>
                  </div>
                </div>
              ) : (
                <StripeProvider apiKey={constants.STRIPE_API_KEY}>
                  <Elements>
                    <CheckoutForm shareId={this.state.shareId} offerId={this.state.offerId} paymentComplete={this.paymentComplete} processPayment={this.processPayment} price={this.state.offerPrice || this.state.price} shippingCost={shipping} productId={this.state.productId} paypalEmail={this.state.paypalEmail} trackingUpgrade={trackingUpgrade} onTaxChange={this.onTaxChange} onShippingValidChange={this.onShippingValidChange} />
                  </Elements>
                </StripeProvider>
              )}
            </div>

            {/* Right: Order summary */}
            <div className="md:tw-col-span-2">
              <div className="tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-border tw-border-[#e0e0e0] dark:tw-border-[#2a2a2a] tw-p-5">
                <h2 className="tw-text-lg tw-font-bold tw-text-[#111] dark:tw-text-white tw-mb-4">Order Summary</h2>

                {/* Item */}
                <div className="tw-flex tw-gap-3 tw-mb-4">
                  {this.state.image1 ? (
                    <img alt="product" src={this.state.image1} className="tw-w-20 tw-h-20 tw-rounded-lg tw-object-contain tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-white dark:tw-bg-[#1a1a1a] tw-flex-shrink-0" />
                  ) : (
                    <div className="tw-w-20 tw-h-20 tw-rounded-lg tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f] tw-flex-shrink-0"></div>
                  )}
                  <div className="tw-flex-1 tw-min-w-0">
                    <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white tw-truncate">{this.state.title}</p>
                    <p className="tw-text-xs tw-text-[#888] tw-mt-1">{this.state.category}</p>
                  </div>
                  <div className="tw-flex-shrink-0 tw-text-right">
                    {hasOffer && <p className="tw-text-xs tw-text-[#999] tw-line-through tw-mb-0">${originalPrice.toFixed(2)}</p>}
                    <p className="tw-text-sm tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-0">${price.toFixed(2)}</p>
                  </div>
                </div>

                {/* Shipping */}
                <div className="tw-flex tw-justify-between tw-py-3 tw-border-t tw-border-[#e0e0e0] dark:tw-border-[#2a2a2a]">
                  <span className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa]">Shipping</span>
                  {shipping > 0 ? (
                    <span className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">${shipping.toFixed(2)}</span>
                  ) : (
                    <span className="tw-text-sm tw-font-medium tw-text-green-600 dark:tw-text-green-400">Free</span>
                  )}
                </div>

                {/* Tracking Upgrade */}
                {canUpgradeTracking && (
                  <div className="tw-flex tw-justify-between tw-items-center tw-py-3 tw-border-t tw-border-[#e0e0e0] dark:tw-border-[#2a2a2a]">
                    <label className="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-mb-0">
                      <input type="checkbox" checked={!!this.state.trackingUpgrade} onChange={this.toggleTracking} className="tw-w-5 tw-h-5 tw-flex-shrink-0 tw-accent-brand-gold" />
                      <span className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa] tw-leading-normal">Add Tracking</span>
                    </label>
                    <span className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">+${TRACKING_FEE.toFixed(2)}</span>
                  </div>
                )}

                {/* Transaction Fee */}
                <div className="tw-flex tw-justify-between tw-py-3 tw-border-t tw-border-[#e0e0e0] dark:tw-border-[#2a2a2a]">
                  <span className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa]">Transaction Fee</span>
                  <span className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">${TRANSACTION_FEE.toFixed(2)}</span>
                </div>

                {/* Estimated Tax */}
                <div className="tw-flex tw-justify-between tw-py-3 tw-border-t tw-border-[#e0e0e0] dark:tw-border-[#2a2a2a]">
                  <span className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa]">
                    {'Estimated Tax'}
                    {taxRate > 0 ? ' (' + (taxRate * 100).toFixed(2) + '%)' : ''}
                  </span>
                  {this.state.taxLoading ? (
                    <span className="tw-text-[#999] dark:tw-text-gray-500"><i className="fa fa-spinner fa-spin" style={{ fontSize: '10px' }} /></span>
                  ) : taxRate > 0 ? (
                    <span className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">${taxAmount.toFixed(2)}</span>
                  ) : (
                    <span className="tw-text-xs tw-italic tw-text-[#999] dark:tw-text-gray-500">Enter zip for tax</span>
                  )}
                </div>

                {/* Total */}
                <div className="tw-flex tw-justify-between tw-py-3 tw-border-t tw-border-[#e0e0e0] dark:tw-border-[#2a2a2a]">
                  <span className="tw-text-base tw-font-bold tw-text-[#111] dark:tw-text-white">Total</span>
                  <span className="tw-text-base tw-font-bold" style={{ color: '#c9a84c' }}>${total.toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default PurchaseSharedPost;
